import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=6ed978b6&"
import script from "./barChart.vue?vue&type=script&lang=ts&"
export * from "./barChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports